import React from "react";
import './footer.sass'
export default function Footer() {
  return (
    <footer>
      © Copyright 2025 ZIG INCOPORATED All Rights Reserved
    </footer>
  );
}
